import { createGlobalStyle } from 'styled-components'

export const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  /* Colori del tema per gli stili inline (dove theme non e' accessibile) */
  :root {
    --text-primary: ${props => props.theme.colors.text.primary};
    --text-secondary: ${props => props.theme.colors.text.secondary};
    --text-tertiary: ${props => props.theme.colors.text.tertiary};
    --text-muted: ${props => props.theme.colors.text.muted};
    --bg-primary: ${props => props.theme.colors.background.primary};
    --bg-secondary: ${props => props.theme.colors.background.secondary};
    --bg-tertiary: ${props => props.theme.colors.background.tertiary};
    --border-light: ${props => props.theme.colors.border.light};
    --border-medium: ${props => props.theme.colors.border.medium};
  }

  html, body {
    height: 100%;
    width: 100%;
  }

  body {
    font-family: ${props => props.theme.typography.fontFamily};
    font-size: 22px;
    background: ${props => props.theme.colors.background.page};
    color: ${props => props.theme.colors.text.secondary};
    transition: background 0.3s ease, color 0.3s ease;
    overflow-x: hidden;

    @media (max-width: 768px) {
      font-size: 16px;
    }
  }

  #root {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }

  /* Scrollbar Styling */
  ::-webkit-scrollbar {
    width: 12px;
    height: 12px;
  }

  ::-webkit-scrollbar-track {
    background: ${props => props.theme.colors.scrollbar.track};
  }

  ::-webkit-scrollbar-thumb {
    background: ${props => props.theme.colors.scrollbar.thumb};
    border-radius: 6px;
    border: 2px solid ${props => props.theme.colors.scrollbar.track};
  }

  ::-webkit-scrollbar-thumb:hover {
    background: ${props => props.theme.colors.scrollbar.thumbHover};
  }

  ::-webkit-scrollbar-thumb:active {
    background: ${props => props.theme.colors.scrollbar.thumbActive};
  }

  /* Firefox Scrollbar */
  * {
    scrollbar-width: thin;
    scrollbar-color: ${props => props.theme.colors.scrollbar.thumb} ${props => props.theme.colors.scrollbar.track};
  }

  /* Selection */
  ::selection {
    background: ${props => props.theme.colors.semantic.primary};
    color: ${props => props.theme.colors.text.inverse};
  }

  ::-moz-selection {
    background: ${props => props.theme.colors.semantic.primary};
    color: ${props => props.theme.colors.text.inverse};
  }

  /* Links */
  a {
    color: ${props => props.theme.colors.semantic.primary};
    text-decoration: none;
    transition: ${props => props.theme.transitions.default};

    &:hover {
      opacity: 0.8;
    }
  }

  /* Form elements default styling */
  input, select, textarea, button {
    font-family: ${props => props.theme.typography.fontFamily};
  }

  /* Form elements color styling for dark mode */
  input, select, textarea {
    color: ${props => props.theme.colors.text.primary};
  }

  /* Select dropdown options styling */
  option {
    background: ${props => props.theme.colors.background.primary};
    color: ${props => props.theme.colors.text.primary};
  }

  /* Disable default outline, we use custom focus styles */
  button:focus,
  input:focus,
  select:focus,
  textarea:focus {
    outline: none;
  }

  /* Image optimization */
  img {
    max-width: 100%;
    height: auto;
  }

  /* Utility classes */
  .visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }
`
